<template>
  
  <div>
    <div class="FooterMap">
      <div class="module">
        <div class="top">
          <div class="left">
            <div>
              <div>核心产品</div>
              <div>
                <div v-jump="'/product/product3'">ZTMap3D</div>
                <div v-jump="'/product/product4'">ZTMapVR</div>
                <div v-jump="'/product/product1'">ZTMapGIS</div>
                <div v-jump="'/product/product2'">ZTMapEasy</div>
                <div v-jump="'/product/product5'">ZTMapIndoor</div>
              </div>
            </div>
            <div>
              <div>更多内容</div>
              <div>
                <div v-jump="'/application'">行业应用</div>
                <div v-jump="'/case'">经典案例</div>
                <div v-jump="'/service'">服务中心</div>
                <div v-jump="'/about'">关于我们</div>
              </div>
            </div>
            <div>
              <div>联系我们</div>
              <div>
                <div>
                  地址：
                  <br />上海市闵行区顾戴路2337号B栋7楼
                </div>
                <div>
                  邮箱：
                  <br />sales@ztmapinfo.com
                </div>
                <div>
                  电话：
                  <br />021-52210295 18018500883(微信)
                </div>
                <div>
                  QQ：
                  <br />2680574633
                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <div>关注我们</div>
            <div>
              <div>
                <div>兜逛VR</div>
                <img src="../assets/images/footer/qrcode1.png" />
              </div>
              <div>
                <div>微信公众号</div>
                <img src="../assets/images/footer/qrcode2.png" />
              </div>
            </div>
          </div>
        </div>
        <div class="bottom">
          <a target="_blank" style="color:#fff" href="https://beian.miit.gov.cn" class="content">上海臻图攀恒科技有限公司  沪ICP备2024107645号-1</a><a href="https://vr.ztmapinfo.com/static/images/yyzzimg.jpg" target="_blank" style="color:#fff"><img style="width: 12px;height: 12px;margin-left: 5px;" src="../assets/images/footer/gongshang.png">营业执照</a>
        </div>
      </div>
    </div>
    <div class="mobile-footer">
      <div class="main-content">
        <div class="content-left">
          <p>核心产品</p>
          <div v-jump="'/product/product3'">ZTMap3D</div>
          <div v-jump="'/product/product4'">ZTMapVR</div>
          <div v-jump="'/product/product1'">ZTMapGIS</div>
          <div v-jump="'/product/product2'">ZTMapEasy</div>
          <div v-jump="'/product/product5'">ZTMapIndoor</div>
        </div>
        <div class="content-left">
          <p>更多内容</p>
          <div v-jump="'/application'">行业应用</div>
          <div v-jump="'/case'">经典案例</div>
          <div v-jump="'/service'">服务中心</div>
          <div v-jump="'/about'">关于我们</div>
        </div>
      </div>
      <div class="call">
        <p>联系我们</p>
        <div class="call-content">
          <div class="item">
            <img src="../assets/images/footer/address.png" alt="">
            <span>地址： 上海市闵行区顾戴路2337号B栋7楼</span>
          </div>
          <div class="item">
            <img src="../assets/images/footer/email.png" alt="">
            <span>邮箱： sales@ztmapinfo.com</span>
          </div>
          <div class="item">
            <img src="../assets/images/footer/tel.png" alt="">
            <span>电话： 021-52210295 18018500883(微信)</span>
          </div>
          <div class="item">
            <img src="../assets/images/footer/qq.png" alt="">
            <span>QQ： 2680574633</span>
          </div>
        </div>
      </div>
      <div class="concern">
        <p>关注我们</p>
        <div class="code-group">
          <div class="qr-code">
            <img src="../assets/images/footer/qrcode1.png" alt="">
            <span>兜逛VR</span>
          </div>
          <div class="qr-code">
            <img src="../assets/images/footer/qrcode2.png" alt="">
            <span>微信公众号</span>
          </div>
        </div>
        <p class="bottom-text">上海臻图攀恒科技有限公司  沪ICP备2024107645号-1<a href="https://vr.ztmapinfo.com/static/images/yyzzimg.jpg" target="_blank" style="color:#fff"><img style="width: 12px;height: 12px;margin-left: 5px;" src="../assets/images/footer/gongshang.png">营业执照</a></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterMap',
  props: ['data'],
  data () {
    return {}
  },
  mounted: function () {},
  methods: {}
}
</script>

<style scoped lang="less">
.FooterMap {
  background: url("../assets/images/footer/footer_bg.jpg") no-repeat center
    center / cover;
  height: 577px;
  .top {
    height: 450px;
    padding-top: 123px;
    box-sizing: border-box;
    color: #fff;
    display: flex;
    .left {
      display: flex;
      width: 777px;
      > div {
        flex: 1;
        > div {
          font-size: 20px;
          margin-bottom: 38px;
          > div {
            font-size: 14px;
            line-height: 24px;
            margin-bottom: 20px;
            cursor: pointer;
          }
        }
        &:nth-child(3) {
          > div:nth-child(2) {
            > div {
              margin-bottom: 10px;
              padding-left: 25px;
              background-repeat: no-repeat;
              background-position: left top 5px;
              cursor: default;
              &:nth-child(1) {
                background-image: url("../assets/images/footer/address.png");
                background-size: 17px 21px;
              }
              &:nth-child(2) {
                background-image: url("../assets/images/footer/email.png");
                background-size: 17px 13px;
              }
              &:nth-child(3) {
                background-image: url("../assets/images/footer/tel.png");
                background-size: 15px 20px;
              }
              &:nth-child(4) {
                background-image: url("../assets/images/footer/qq.png");
                background-size: 17px 20px;
              }
            }
          }
        }
      }
    }
    .right {
      flex: 1;
      height: 260px;
      border-left: 1px solid rgba(255, 255, 255, 0.2);
      > div {
        font-size: 20px;
        margin-bottom: 38px;
        &:first-child {
          padding-left: 155px;
        }
        &:last-child {
          text-align: right;
        }
        > div {
          display: inline-block;
          margin-left: 40px;
          > div {
            font-size: 14px;
            color: rgba(255, 255, 255, 0.5);
            margin-bottom: 19px;
            text-align: left;
          }
          > img {
            width: 110px;
            height: 110px;
          }
        }
      }
    }
  }
  .bottom {
    height: 126px;
    border-top: 1px solid rgba(255, 255, 255, 0.2);
    background: url("../assets/images/footer/logo.png") no-repeat left center /
      136px 30px;
    line-height: 126px;
    text-align: right;
    color: #fff;
    font-size: 12px;
  }
}
.mobile-footer {
  width: 100%;
  height: 52rem;
  background: linear-gradient(0deg, #3374EF 0%, #86C0F9 100%);
  box-sizing: border-box;
  padding: 2rem;
  color: #FFFFFF;
  font-family: 'Normal';
  display: none;
  flex-direction: column;
  .main-content {
    height: 15rem;
    width: 100%;
    display: flex;
    .content-left {
      width: 50%;
      height: 100%;
      display: flex;
      flex-direction: column;
      p {
        font-size: 1.4rem;
        font-weight: bold;
        line-height: 2.2rem;
      }
      div {
        font-size: 1rem;
        font-weight: 350;
        line-height: 2rem;
        cursor: pointer;
      }
    }
  }
  .call {
    width: 100%;
    height: 13rem;
    >p {
      font-size: 1.4rem;
      font-weight: bold;
      line-height: 2rem;
    }
    .call-content {
      width: 100%;
      display: flex;
      flex-direction: column;
      .item {
        width: 100%;
        display: flex;
        align-items: center;
        img {
          width: 0.8rem;
          height: 1rem;
        }
        >span {
          margin-left: 1rem;
          font-size: 1rem;
          font-weight: 350;
          line-height: 2rem;
        }
      }
    }
  }
  .concern {
    width: 100%;
    height: 15rem;
    >p {
      font-size: 1.4rem;
      font-weight: bold;
      line-height: 2rem;
    }
    .code-group {
      width: 100%;
      display: flex;
      justify-content: space-around;
      .qr-code {
        width: 10rem;
        height: 10rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        >img {
          width: 100%;
          height: 100%;
        }
        >span {
          margin-top: 1rem;
          font-size: 1rem;
          font-weight: 350;
          line-height: 2rem;
        }
      }
    }
    .bottom-text {
      width: 100%;
      font-size: 1rem;
      font-weight: 350;
      line-height: 2rem;
      text-align: center;
      margin-top: 3.5rem;
    }
  }
}
.content {
  height: 100%;
}
@media (max-width: 1024px) {
  .FooterMap {
    display: none !important;
  }
  .mobile-footer { 
    display: flex !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FooterMap.vue